import { Component, OnInit, ViewChild, OnDestroy, Input } from '@angular/core';
import { MessageService } from '../message.service';
import { Subscription } from 'rxjs';
import { RestApiService } from '../rest-api.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { NgbModal, ModalDismissReasons, NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SocketService } from '../socket.service';
import { AngularGridInstance, Formatters, GridOption, GridOdataService, FieldType } from 'angular-slickgrid';
import { FormControl } from '@angular/forms';

// import { TranslateService } from '@ngx-translate/core';
const defaultPageSize = 50;

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit, OnDestroy {
    clientName: string;
    userGroups: any;
    userGroupId: number;
    groupName: string;
    grpLevel: number;
    respObject: any;
    tilesData = [];
    isLabel0: boolean;
    isLabel1: boolean;
    isLabel2: boolean;
    islead: boolean;
    cat1: any;
    cat2: any;
    private userAuth: Subscription;
    private ticketTypeSubscription: Subscription;
    ticketTypeLoaded = false;
    notifier: NotifierService;
    modal: any;
    radius: number;
    clientId: number;
    categories = [];
    categorySelected: number;
    errorMessage: string;
    isError = false;
    users = [];
    userSelected: number;
    isLoading: boolean;
    ticketTypeSelected: number;
    ticketTypeId: number;
    ticketId: string;
    ticket_type: string;
    statusSelected: number;
    supportGroupSelected: number;
    priorities = [];
    prioritySelected: number;
    raised: string;
    raisedTypeSelected: number;
    minDate: any;
    maxDate: any;
    ticketTypes = [];
    attachment = [];
    cat = [];
    dynamicFields: any;
    priorityType: number;
    priority: string;
    fromDate: string;
    toDate: string;
    startDate: string;
    endDate: string;
    lead: string;
    selectedTitles = [];
    selectedTitles2 = [];
    selectedTitles4 = [];
    gridOptions: GridOption;
    angularGrid: AngularGridInstance;
    columnDefinitions = [];
    dataset: any[];
    show: boolean;
    selected: number;
    ticketCreated = false;
    defaultStatus = false;
    defaultUser = false;
    defaultNextUser = false;
    name: string;
    desc: string;
    brief: string;
    rDate: string;
    dDate: string;
    comment: string;
    percent: number;
    solution: string;
    types = [];
    assignedUser: any;
    assignedGroup: any;
    currentUser: string;
    currentGroup: string;
    groups = [];
    status = [];
    assignee_copy: string;
    private tId: any;
    lastCatId: number;
    lastParentId: number;
    statusName: string;
    respTime: string;
    comments = [];
    assignedToMe = false;
    closedticket = false;
    endIndicator = true;
    slaViolated = false;
    logs = [];
    count: number;
    solutions = [];
    private modalReference: NgbModalRef;
    createdByMe = false;
    attachments = [];
    uploadButtonName = 'Upload File';
    fileUploadUrl: string;
    menus = [];
    ticketTab = true;
    commentsTab = true;
    solTab = true;
    attachTab = true;
    logTab = true;
    tabs: any;
    solLoaded: boolean;
    comLoaded: boolean;
    resoTime: string;
    hideAttachment: boolean;
    attachMsg: string;
    isAddIncident: boolean;
    isViewIncident: boolean;
    canAddSolution: boolean;
    canAddComment: boolean;
    showGrid1 = false;
    showGridForViewIncident = false;
    showGridForAddIncident = false;
    showGrid = false;
    step: string;
    assignGroupLength: number;
    isApprovedTicket: boolean;
    isApproved: string;
    worker: any;
    actions = [];
    statusSeq: number;
    escalatedTicket = false;
    seq: number;
    isAsset: boolean;
    assetDisplayed: boolean;
    slaString: any;
    outerColor: any;
    innerColor: any;
    isRInfo: boolean;
    loginName: string;
    email: string;
    mobile: string;
    username: string;
    LIMIT = 7;
    start = 0;
    diplaySLAMeter: boolean;
    private baseCategories = [];
    statusDisabled: boolean;
    replyHideAttachment: boolean;
    solProvided = false;
    displayNewComment: boolean;
    displayNewAttachment: boolean;
    displayNewSolutions: boolean;
    escLevel: string;
    public activateUserReplay: boolean;
    isFollowUp: boolean;
    replyAttachment = [];
    isSelfAssigned: boolean;
    claimNo: string;
    displayClaimNo: boolean;
    isLowestLevel: boolean;
    respPercent: number;
    slaViolatedResp = false;
    slaStringResp: string;
    outerColorResp: any;
    innerColorResp: any;
    lastCommentUser: string;
    private commentSubscribe: Subscription;
    lastComment: string;
    public followUpSelected: number;
    public followUps = [];
    lastSol: string;
    wGroups = [];
    allTicketTypes = [];
    assignee = [];
    assigneeSelected: number;
    ticketStatusSelected: number;
    ticket_id: string;
    ticketIdSearchLoaded: boolean;
    hasFollowupUser: boolean;
    followupUser: string;
    catFilterVal = 0;
    userFilterVal = 0;
    statusComment: string;
    private INCIDENT_TYPE_SEQ = 1;
    usersReply: string;
    psInfo = [];
    viewIncidentData = [];
    addIncidentData = [];
    allStatus = [];
    categoryLoaded = false;
    inciCategories = [];
    filterSearchLoaded: boolean;
    searchTid: string;
    searchCat = [];
    inciId: number;
    columnData = [];
    gridObj: any;
    ticketCount: number;
    private closeModalSubscribe: Subscription;
    private attachmentSubscribe: Subscription;
    addIncidentStatus: number;
    folderLoaded = false;
    displayed = true;
    folderDisplayed = true;
    masterNameObj = [];
    masterNameSelected: number;
    masterDataNameSelected: number;
    data = [];
    data2 = [];
    totalData: number;
    @ViewChild('groupSelect') private groupSelect;
    @ViewChild('statusChange') private statusChange;
    @ViewChild('content') content;
    subRadioDisplay: boolean;
    userGroupSelected = 0;
    typeChecked: string;
    typeSeq: any;
    private aGrpLvl: number;
    dataLoaded: boolean;
    isChangeStatus: boolean;
    isUserReplied: boolean;
    subTypeId: any;
    categoryFilter: string;
    private userName: string;
    private priorityId: any;
    isSearch: boolean;
    private storage: any;
    nextOffset: number;
    pageSize: number;
    top: number;
    skip: number;
    query: any;
    service: any;
    pageSizeObj: any[];
    pageNo: number;
    totalPage: number;
    pageSizeSelected: number;
    paginationObj: any;
    offset: number;
    previousOffset: number;
    page_no: number;
    isCreateTicket: boolean;
    private AWAITING_USER_REPLY_SEQ = 12;

    isExport: boolean;
    tikt_Id: FormControl = new FormControl();
    exportdata: any;


    constructor(private messageService: MessageService, private _rest: RestApiService,
        private actRoute: ActivatedRoute, private route: Router, notifier: NotifierService,
        private modalService: NgbModal, private socketService: SocketService, private dialog: MatDialog
    ) {
        this.notifier = notifier;
    }

    angularGridReady(angularGrid: AngularGridInstance) {
        // console.log('grid initiate');
        this.angularGrid = angularGrid;
        this.gridObj = angularGrid && angularGrid.slickGrid || {};
    }

    ngOnInit() {
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.isCreateTicket = false;
        this.page_no = 0;
        this.pageSizeObj = this.messageService.searchPagination;
        this.pageSizeSelected = this.messageService.searchPageSelected;
        this.pageSize = this.messageService.searchPageSize;
        this.pageNo = 0;
        this.paginationObj = { 'offset': this.nextOffset, 'paginationType': '' };
        this.totalPage = 0;
        this.skip = 0;
        this.totalData = 0;
        this.isSearch = true;
        this.categoryFilter = '';
        this.toDate = '';
        this.fromDate = '';
        this.fileUploadUrl = this._rest.apiRoot + '/updateFile';
        this.ticketIdSearchLoaded = true;
        const now = new Date();
        const nowDate = new Date();
        const nowMonth = nowDate.getMonth();
        const nowDay = nowDate.getDate();
        const nowYear = nowDate.getFullYear();
        this.maxDate = new Date(nowYear, nowMonth, nowDay);
        // this.toDate = this.formatDate(this.maxDate);
        this.endDate = this.messageService.ticketConverter(this.maxDate, 1);
        const previousDate = new Date(now.setDate(now.getDate() - 1));
        const previousMonth = previousDate.getMonth();
        const previousDay = previousDate.getDate();
        const previousYear = previousDate.getFullYear();
        this.minDate = new Date(previousYear, previousMonth, previousDay);
        // this.fromDate = this.formatDate(this.minDate);
        this.startDate = this.messageService.ticketConverter(this.minDate, 1);
        // console.log(this.fromDate + '==========' + this.toDate);
        this.ticket_id = '';
        this.isRInfo = false;
        this.isLoading = false;
        this.isLabel0 = false;
        this.isLabel1 = false;
        this.isLabel2 = false;
        this.islead = false;
        this.statusSelected = 0;
        this.addIncidentStatus = 0;
        this.prioritySelected = 0;
        this.userSelected = 0;
        this.ticketStatusSelected = 0;
        this.raised = '';
        this.raisedTypeSelected = 0;
        this.assigneeSelected = 0;
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.userGroups = this.messageService.groupId;
            this.userName = this.messageService.loginName;
            if (this.messageService.getSupportGroup() === null) {
                this.userGroupId = this.userGroups[0].groupId;
                this.groupName = this.userGroups[0].grpName;
                this.grpLevel = this.userGroups[0].level;

            } else {
                const group = this.messageService.getSupportGroup();
                // // console.log(group, typeof group);
                this.userGroupId = group.groupId;
                this.groupName = group.grpName;
                this.grpLevel = group.level;
            }
            this.userGroupSelected = this.userGroupId;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.clientId = auth[0].clientId;
                this.userGroups = auth[0].groupId;
                this.userName = auth[0].login_name;
                if (this.messageService.getSupportGroup() === null) {
                    this.userGroupId = this.userGroups[0].groupId;
                    this.groupName = this.userGroups[0].grpName;
                    this.grpLevel = this.userGroups[0].level;

                } else {
                    const group = this.messageService.getSupportGroup();
                    // // console.log(group, typeof group);
                    this.userGroupId = group.groupId;
                    this.groupName = group.grpName;
                    this.grpLevel = group.level;
                }
                this.userGroupSelected = this.userGroupId;
                this.onPageLoad();
            });
        }

        this.gridOptions = {
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableFiltering: true,
            editable: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            // enableCheckboxSelector: true,
            enableRowSelection: true,

        };
    }

    setParameter(query) {
        return new Promise((resolve, reject) => {
            this.query = query;
            // console.log('this.query1111===', this.query + '====' + this.nextOffset);
            // const queryParams = query.toLowerCase().split('&');
            // for (const param of queryParams) {
            //     if (param.includes('$skip=')) {
            if (this.fromDate !== '' || this.toDate !== '') {
                // this.advanceSearch(this.query, 0);
            }
            // }
            // }
            resolve(this.query);
        });
    }

    exportToExcel() {
        let ticketId;
        const tdate = this.messageService.ticketConverter(this.toDate, 1);
        if (tdate !== '') {
            this.toDate = tdate;
        } else {
            this.toDate = this.endDate;
        }
        const fdate = this.messageService.ticketConverter(this.fromDate, 1);
        if (fdate !== '') {
            this.fromDate = fdate;
        } else {
            this.fromDate = this.startDate;
        }
        const date1 = new Date(this.fromDate).valueOf();
        const date2 = new Date(this.toDate).valueOf();
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        let isError = false;
        // let cats;
        // console.log('this.cat.length====' + JSON.stringify(this.cat));
        if (this.cat.length > 0) {
            this.categoryFilter = '';
        }
        for (let i = 0; i < this.cat.length; i++) {
            if (this.cat[i].cid !== 0) {
                // console.log('this.cat===' + JSON.stringify(this.cat[i]));
                this.categoryFilter += this.cat[i].pid + '#' + this.cat[i].cid;
                if (i !== this.cat.length - 1) {
                    this.categoryFilter += ',';
                }
            } else {
                isError = true;
                break;
            }
        }
        const lastChar = this.categoryFilter.substr(-1);
        if (lastChar === ',') {
            this.categoryFilter = this.categoryFilter.substr(0, this.categoryFilter.length - 1);
        }


        if (this.categoryFilter === '') {
            this.categoryFilter = '0';
        }

        if (this.grpLevel > 1 || this.islead) {
            this.lead = 'Y';
        } else {
            this.lead = 'N';
        }

        if (this.ticket_id === '') {
            ticketId = 0;
        } else {
            ticketId = this.ticket_id;
        }

        if (this.raised !== '') {
            this.raisedTypeSelected = 1;
        } else {
            this.raisedTypeSelected = 0;
        }

        const data = {
            'ticketTypeId': this.ticketTypeId,
            'clientId': this.clientId,
            'supportgrp_id': this.userGroupSelected,
            'ticketStatusId': this.ticketStatusSelected,
            'ticket_id': ticketId,
            'busi_priority_id': this.prioritySelected,
            'created_frdate': this.fromDate,
            'created_todate': this.toDate,
            'catFilterLt': this.categoryFilter,
            'isTeamLead': this.lead,
            'raisedType': this.raisedTypeSelected,
            'raisedValue': this.raised,
            'assign_id': this.assigneeSelected,
            'grpLevel': this.grpLevel,
            'isDashboardSearch': 1,
            'ticketTypeSeqNo': this.seq,
        };
        if (ticketId.length < 6) {
            this.notifier.notify('error', 'Please enter last 6 digits of ticket id');
        } else if (this.raised !== '' && this.raisedTypeSelected === 0) {
            this.notifier.notify('error', 'Please select raised type');
        } else if (Number(diffDays) > 31) {
            this.notifier.notify('error', this.messageService.REPORT_TIME);
        } else {
            this.ticketIdSearchLoaded = false;
            this._rest.searchSscDataForExport(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.ticketIdSearchLoaded = true;
                    this.exportdata = this.respObject.details;
                    const exportArr = [];
                    for (let i = 0; i < this.exportdata.length; i++) {
                        const category = this.respObject.details[i].category;
                        const cat = category.split(',');
                        for (let j = 0; j < cat.length; j++) {
                            const cat1 = cat[j].split('->');
                            // console.log('@@@category===' + JSON.stringify(cat1));
                            this.exportdata[i][cat1[0]] = cat1[1];
                        }
                        if (this.exportdata[i].ticketCloseDate === undefined || this.exportdata[i].ticketCloseDate === '' ||
                            this.exportdata[i].ticketCloseDate === null) {
                            this.exportdata[i].ticketCloseDate = '';
                        } else {
                            this.exportdata[i].ticketCloseDate =
                                this.messageService.datePipeFunc(this.exportdata[i].ticketCloseDate);
                        }
                        exportArr.push({
                            'Ticket Id': this.exportdata[i].ticket_id,
                            'Created By': this.exportdata[i].createdBy,
                            'Created Since': this.messageService.datePipeFunc(this.exportdata[i].createdSince),
                            'Status': this.exportdata[i].status,
                            'RequesterInfo': this.exportdata[i].reqInfo,
                            'Assignee': this.exportdata[i].assignee,
                            'Group': this.exportdata[i].LEVELSHORTDESC,
                            'Due Date': this.messageService.datePipeFunc(this.exportdata[i].dDate),
                            'Closure Date': this.exportdata[i].ticketCloseDate,
                            'Escalation Level': this.exportdata[i].escalated_to_grp_nm,
                            'Business Entity': this.exportdata[i].BusinessEntity,
                            'Process Area': this.exportdata[i].ProcessArea,
                            'Function': this.exportdata[i].Function,
                            'Module': this.exportdata[i].Module,
                            'Sub Module': this.exportdata[i].SubModule,
                            'Ticket Title': this.exportdata[i].tName,
                            'Entity': this.exportdata[i].entity_code,
                            'IC': this.exportdata[i].ic,
                            'SBU': this.exportdata[i].sbu,
                            'Location': this.exportdata[i].location,
                            'Band': this.exportdata[i].band,
                            'Priority': this.exportdata[i].priority
                        });
                        if (this.isLabel0 === true) {
                            delete exportArr[i]['Priority'];
                        }
                    }
                    // console.log("----------------" + JSON.stringify(exportArr))
                    this.messageService.exportAsExcelFile(exportArr);
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            });
        }
    }


    onPageLoad() {
        this.isLoading = true;
        this.tilesData = [];
        this.tikt_Id.valueChanges.subscribe(
            ticketIdd => {
                if (ticketIdd.length > 0) {
                    this.isExport = true;
                } else {
                    this.isExport = false;
                }
            })
        this.ticketTypeSubscription = this._rest.getTicketTypeForTicketCreation_LNT(this.clientId, this.userGroupId).subscribe((res1) => {
            this.respObject = res1;
            this.ticketTypeLoaded = true;
            if (this.respObject.success) {
                this.storage = JSON.parse(sessionStorage.getItem('dd'));
                // this.respObject.details.unshift({id: 0, name: 'Select ticket type'});
                this.types = this.respObject.details;
                // console.log('this.type====', this.types);
                // this.ticketTypeId = this.types[this.ticketTypeSelected].id;
                // this.seq = this.types[this.ticketTypeSelected].seq;
                // console.log('this.storage====', JSON.stringify(this.storage));
                if (this.storage === null) {
                    this.ticketTypeId = this.types[0].id;
                    this.seq = this.types[0].seq;
                } else {
                    const type = this.storage.type;
                    this.types[0].checked = false;
                    for (let i = 0; i < this.types.length; i++) {
                        // console.log(this.types[i].id, type);
                        if (this.types[i].id === type) {
                            this.ticketTypeId = this.types[i].id;
                            this.types[i].checked = true;
                            this.seq = this.types[i].seq;
                            this.types[i].checked = true;
                            break;
                        }
                    }
                    // console.log('seq---------> : ' + this.seq);
                }

                if (this.seq === 1) {
                    this.ticketTypeSelected = 0;
                } else if (this.seq === 2) {
                    this.ticketTypeSelected = 1;
                }
                // ======================================================
                this.getStatus(this.seq);
                this._rest.getBusinessPriorityTicketTypeWise(this.clientId, this.ticketTypeId).subscribe((res2) => {
                    this.respObject = res2;
                    if (this.respObject.success) {
                        this.isError = false;
                        this.respObject.details.unshift({ id: 0, name: 'Select Priorities' });
                        this.priorities = this.respObject.details;
                        this.prioritySelected = 0;
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = this.messageService.SERVER_ERROR;
                });
                this.getColumnDefintion();
                for (let i = 0; i < this.types.length; i++) {
                    if (this.types[i].seq === this.INCIDENT_TYPE_SEQ) {
                        this.inciId = this.types[i].id;
                        break;
                    }
                }

                this._rest.checkIsLead(this.clientId, this.userGroupId, this.messageService.getUserId()).subscribe((res3) => {
                    this.respObject = res3;
                    if (this.respObject.success) {
                        this.islead = this.respObject.details[0].is_spoc;
                        this.setFirstSecondCategoryLevel();
                        if (this.grpLevel !== 0 && !this.islead) {
                            this._rest.getUserByGroup(this.clientId, this.userGroupSelected).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.isError = false;
                                    this.respObject.details.unshift({ id: 0, name: 'Select User' });
                                    this.assignee = this.respObject.details;
                                    this.assigneeSelected = 0;
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            });
                        } else if (this.grpLevel === 1 && this.islead) {
                            this._rest.getAllLevelOneUser(this.clientId).subscribe((res5) => {
                                this.respObject = res5;
                                if (this.respObject.success) {
                                    this.isError = false;
                                    this.respObject.details.unshift({ id: 0, name: 'Select User' });
                                    this.assignee = this.respObject.details;
                                    this.assigneeSelected = 0;
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                // this.isError = true;
                                // this.errorMessage = this.messageService.SERVER_ERROR;
                            });
                        } else {
                            this.assigneeSelected = Number(this.messageService.getUserId());
                        }
                    } else {

                    }
                });
            }
        });
        if (this.grpLevel === 0) {
            this.isLabel0 = true;
        } else if (this.grpLevel === 1) {
            this.isLabel1 = true;
        } else if (this.grpLevel >= 2) {
            this.isLabel2 = true;
        }
    }

    setFirstSecondCategoryLevel() {
        if (this.seq === 1) {
            const cat = this.messageService.getCategory1();
            if (cat === null) {
                this.notifier.notify('error', this.messageService.NO_CATEGORY_FOUND);
                this.messageService.logOut();
            } else {
                this.cat1 = cat.cat1;
                this.cat2 = cat.cat2;
                this.getTicketLoadingDataWithAttr();
            }
        }
        if (this.seq === 2) {
            const cat = this.messageService.getCategory2();
            if (cat === null) {
                this.notifier.notify('error', this.messageService.NO_CATEGORY_FOUND);
                this.messageService.logOut();
            } else {
                this.cat1 = cat.cat1;
                this.cat2 = cat.cat2;
                this.getTicketLoadingDataWithAttr();
            }
        }
    }

    onSelectGroup() {
        // // console.log(typeof this.userGroupSelected);
        if (this.userGroupSelected !== 0) {
            this.userGroupId = this.userGroupSelected;
            for (let i = 0; i < this.userGroups.length; i++) {
                if (this.userGroups[i].groupId === this.userGroupId) {
                    this.groupName = this.userGroups[i].grpName;
                    this.grpLevel = this.userGroups[i].level;
                }
            }
            this.messageService.saveSupportGroup({
                groupId: this.userGroupId,
                grpName: this.groupName,
                level: this.grpLevel
            });
            this.dataset = [];
            this.totalData = 0;
            this.onPageLoad();
        }
    }

    getStatus(sequence) {
        this._rest.getStatusByTicketTypeLt(sequence, this.clientId).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.respObject.details.unshift({ id: 0, status: 'Select Ticket Status' });
                this.allStatus = this.respObject.details;
                this.statusSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    displayTicket(res1, offset, paginationType) {
        this.respObject = res1;
        if (this.respObject.success) {
            // this.dataset = [];
            for (let i = 0; i < this.respObject.details.dataObj.length; i++) {
                this.respObject.details.dataObj[i].createdSince =
                    this.messageService.datePipeFunc(this.respObject.details.dataObj[i].createdSince);
                this.respObject.details.dataObj[i].dDate =
                    this.messageService.datePipeFunc(this.respObject.details.dataObj[i].dDate);
                this.respObject.details.dataObj[i].updateDate =
                    this.messageService.datePipeFunc(this.respObject.details.dataObj[i].updateDate);
                if (this.respObject.details.dataObj[i].ticketCloseDate === undefined || this.respObject.details.dataObj[i].ticketCloseDate === '' ||
                    this.respObject.details.dataObj[i].ticketCloseDate === null) {
                    this.respObject.details.dataObj[i].ticketCloseDate = '';
                } else {
                    this.respObject.details.dataObj[i].ticketCloseDate =
                        this.messageService.datePipeFunc(this.respObject.details.dataObj[i].ticketCloseDate);
                }
                this.respObject.details.dataObj[i].requestedDate =
                    this.messageService.datePipeFunc(this.respObject.details.dataObj[i].requestedDate);
                const category = this.respObject.details.dataObj[i].category;
                const cat = category.split(',');
                for (let j = 0; j < cat.length; j++) {
                    const cat1 = cat[j].split('->');
                    this.respObject.details.dataObj[i][cat1[0]] = cat1[1];
                }
            }
            // this.dataset = this.respObject.details.dataObj;
            // console.log('Dataset===' + JSON.stringify(this.dataset));
            // this.totalItems = this.dataset.length;
            // console.log('this.seq:5' + this.seq);
            // if (this.nextOffset === 0) {
            //     this.gridOptions.pagination.totalItems = this.respObject.details.totalData[0].count;
            // }
            // ========================================================================
            if (offset === 0) {
                this.totalData = this.respObject.details.totalData[0].count;
                this.totalPage = this.respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (this.respObject.details.dataObj.length > 0) {
                this.dataset = this.respObject.details.dataObj;
                this.nextOffset = this.respObject.details.nextOffset;
                this.offset = this.respObject.details.nextOffset;
                this.previousOffset = this.respObject.details.previousOffset;
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }

                if (this.page_no === 1) {
                    this.previousOffset = 0;
                }
            } else if (this.respObject.details.dataObj.length === 0 && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
            //  console.log('n==' + this.nextOffset + '==p===' + this.previousOffset + '===totalData==' + this.totalData + '===pageSize===' +
            //     this.pageSize + '===pageno===' + this.page_no);
            // ========================================================================
            this.gridOptions = Object.assign({}, this.gridOptions);
        } else {
            this.notifier.notify('error', this.respObject.errorMessage);
        }
    }

    resetSearch() {
        this.ticketStatusSelected = 0;
        this.statusSelected = 0;
        this.prioritySelected = 0;
        this.raisedTypeSelected = 0;
        this.ticket_id = '';
        this.raised = '';
        this.dataset = [];
        this.totalData = 0;
        this.toDate = '';
        this.fromDate = '';
        this.categoryFilter = '';
        this.getTicketLoadingDataWithAttr();
        if (this.grpLevel === 1 && this.islead) {
            this.assigneeSelected = 0;
        } else {
            this.assigneeSelected = Number(this.messageService.getUserId());
        }
    }

    getTicketLoadingDataWithAttr() {
        this._rest.getTicketCreateLoadingDtlsForSearch(this.messageService.getUserId(), this.ticketTypeId, this.clientId,
            this.cat1, this.cat2, this.userGroupSelected, this.islead).subscribe((res) => {
                this.respObject = res;
                this.categoryLoaded = true;
                if (this.respObject.success) {
                    if (this.cat2 === '0') {
                        this.respObject.details[0].attribute[1].isDisabled = false;
                        this.respObject.details[0].attribute[1].options.sort(function (a, b) {
                            return a.id - b.id;
                        }
                        );
                    }
                    this.baseCategories = this.messageService.copyArray(this.respObject.details[0].attribute);
                    this.allTicketTypes = this.respObject.details[0].attribute;
                    this.cat = [];
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
    }

    getColumnDefintion() {
        this._rest.getAttributesHeaderMstClientWiseWithTicket(this.clientId, this.ticketTypeId).subscribe((res2) => {
            this.respObject = res2;
            if (this.respObject.success) {
                const data = this.respObject.details;
                // // console.log(JSON.stringify(data));
                this.columnDefinitions = [
                    // {id: 'id', name: 'Id', field: 'id', minWidth: 80, sortable: true, filterable: true},
                    {
                        id: 'ticket_id',
                        name: 'Ticket Id',
                        field: 'ticket_id',
                        minWidth: 200,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'createdBy',
                        name: 'Created By',
                        field: 'createdBy',
                        minWidth: 200,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'createdSince',
                        name: 'Created Since',
                        field: 'createdSince',
                        minWidth: 150,
                        sortable: true,
                        filterable: true,
                        type: FieldType.dateIso
                    },
                    {
                        id: 'status',
                        name: 'Status',
                        field: 'status',
                        sortable: true,
                        minWidth: 150,
                        filterable: true
                    },
                    {
                        id: 'reqInfo',
                        name: 'RequesterInfo',
                        field: 'reqInfo',
                        minWidth: 100,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'assignee',
                        name: 'Assignee',
                        field: 'assignee',
                        minWidth: 200,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'LEVELSHORTDESC',
                        name: 'Group',
                        field: 'LEVELSHORTDESC',
                        minWidth: 100,
                        sortable: true,
                        filterable: true
                    },
                    {
                        id: 'dDate',
                        name: 'Due Date',
                        field: 'dDate',
                        minWidth: 150,
                        sortable: true,
                        filterable: true,
                        type: FieldType.dateIso
                        // formatter: Formatters.dateTimeIso
                    },
                    {
                        id: 'closureDate',
                        name: 'Closure Date',
                        field: 'ticketCloseDate',
                        minWidth: 150,
                        sortable: true,
                        filterable: true,
                        type: FieldType.dateIso
                    },
                    {
                        id: 'escLevel',
                        name: 'Escalation Level',
                        field: 'escalated_to_grp_nm',
                        minWidth: 150,
                        sortable: true,
                        filterable: true
                    }
                ];
                for (let i = 0; i < data.length; i++) {
                    this.columnDefinitions.push({
                        id: data[i].field,
                        name: data[i].name,
                        field: data[i].field,
                        minWidth: 100,
                        sortable: true,
                        filterable: true
                    });
                }
                this.columnDefinitions.push({
                    id: 'title',
                    name: 'Ticket Title',
                    field: 'tName',
                    minWidth: 100,
                    sortable: true,
                    filterable: true
                });
                this.columnDefinitions.push({
                    id: 'entity',
                    name: 'Entity',
                    field: 'entity_code',
                    minWidth: 100,
                    sortable: true,
                    filterable: true
                }, {
                    id: 'ic', name: 'IC', field: 'ic', minWidth: 100, sortable: true, filterable: true
                }, {
                    id: 'sbu', name: 'SBU', field: 'sbu', minWidth: 100, sortable: true, filterable: true
                }, {
                    id: 'loction',
                    name: 'LOCATION',
                    field: 'location',
                    minWidth: 100,
                    sortable: true,
                    filterable: true
                }, {
                    id: 'band', name: 'Band', field: 'band', minWidth: 100, sortable: true, filterable: true
                });
                if (this.grpLevel !== 0) {
                    this.columnDefinitions.push({
                        id: 'priority',
                        name: 'Priority',
                        field: 'priority',
                        minWidth: 100,
                        sortable: true,
                        filterable: true
                    });
                }
                const classes = document.getElementsByClassName('search-filter');
                for (let i = 0; i < classes.length; i++) {
                    classes[i].setAttribute('placeholder', '');
                }
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
    }

    onSelectTicketType(selectedIndex) {
        this.ticketTypeId = this.types[selectedIndex].id;
        this.seq = this.types[selectedIndex].seq;
        this.getStatus(this.seq);
        this.setFirstSecondCategoryLevel();
    }

    onCategoryChange(ticket, option) {
        // console.log('ticket====' + JSON.stringify(ticket));
        // console.log('option===' + option);
        const opt = JSON.parse(option);
        if (opt.type !== 'header') {
            // if (this.attachment.length > 0) {
            //   this.attachment = [];
            // }
            const value = opt.id;
            let matched = false;
            const index = this.allTicketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id + 1);
            // // console.log('index:' + index);
            const index1 = this.allTicketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id);
            const pid = this.allTicketTypes[index1].options[0].id;
            // // console.log(this.allTicketTypes[index1].options[0]);
            // if (index === 3) {
            //     const pid1 = this.baseCategories[0].options[1].id;
            //     const pid2 = this.baseCategories[1].options[1].id;
            //     const cid1 = this.baseCategories[0].options[0].id;
            //     const cid2 = this.baseCategories[1].options[0].id;
            //     if (this.cat.length === 0) {
            //         this.cat.push({pid: pid1, cid: cid1}, {pid: pid2, cid: cid2});
            //     }
            // }

            if (this.cat2 === '0') {
                if (index === 2) {
                    const pid1 = this.baseCategories[0].options[1].id;
                    const pid2 = this.baseCategories[1].options[0].id;
                    const cid1 = this.baseCategories[0].options[0].id;
                    const cid2 = opt.id;
                    if (this.cat.length === 0) {
                        this.cat.push({ pid: pid1, cid: cid1 }, { pid: pid2, cid: cid2 });
                    }
                }
            } else {
                if (index === 3) {
                    const pid1 = this.baseCategories[0].options[1].id;
                    const pid2 = this.baseCategories[1].options[1].id;
                    const cid1 = this.baseCategories[0].options[0].id;
                    const cid2 = this.baseCategories[1].options[0].id;
                    if (this.cat.length === 0) {
                        this.cat.push({ pid: pid1, cid: cid1 }, { pid: pid2, cid: cid2 });
                    }
                }
            }


            if (this.cat.length === 0) {
                this.cat.push({ pid: pid, cid: value });
            } else {
                for (let i = 0; i < this.cat.length; i++) {
                    if (this.cat[i].pid === pid) {
                        matched = true;
                        this.cat[i].cid = value;
                        break;
                    }
                }
                if (!matched) {
                    this.cat.push({ pid: pid, cid: value });
                } else {
                    for (let i = index; i < this.cat.length; i++) {
                        // // console.log('matched');
                        // // console.log(this.cat[i]);
                        if (index > -1) {
                            this.cat[i].cid = 0;
                        }
                    }
                }
            }
            // console.log(JSON.stringify(this.cat));
            // clear sub categories
            if (index > -1) {
                // console.log('index:' + index);
                for (let i = index + 1; i < this.allTicketTypes.length; i++) {
                    const options = this.allTicketTypes[i].options;
                    // console.log(JSON.stringify(options));
                    for (let j = 0; j < options.length; j++) {
                        if (options[j].type) {
                            // options=[];
                            this.allTicketTypes[i].options = [options[j]];
                            break;
                        }
                    }
                }
            }
            // if (index === 3 && this.typeSeq === 1) {
            //     this.selectedCatVal = value;
            //     this.getRSDBData('1');
            // }
            // if (index === 4) {
            //     this.hideClaim = !opt.attachedField;
            // }
            // // console.log(JSON.stringify(this.cat));
            if (ticket.id === 1) {
                this._rest.getTicketFieldsCatWise({
                    clientId: this.clientId,
                    catId: value,
                    ticketTypeId: this.ticketTypeId
                }).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        // // console.log(JSON.stringify(this.respObject.details));
                        for (let i = 0; i < this.respObject.details.length; i++) {
                            if (this.respObject.details[i].predifinedValue !== null) {
                                this.respObject.details[i].values = this.respObject.details[i].predifinedValue.split(',');
                                this.respObject.details[i].value = this.respObject.details[i].values[0];
                            } else {
                                this.respObject.details[i].value = '';
                            }
                        }
                        this.dynamicFields = this.respObject.details;
                    } else {
                        // this.notifier.notify('error', this.respObject.errorMessage);
                    }
                }, (err) => {
                    this.notifier.notify('error', this.messageService.SERVER_ERROR);
                });
            }
            // // console.log('index:'+index);
            let data;
            if (index > -1) {
                data = this.allTicketTypes[index].options[0];
                this.allTicketTypes[index].options = [];
            }

            console.log('Current INDEX ==> ' + index)
            if (this.cat2 === '0') {
                if (index === 2) {
                    this._rest.getCategoryListSupportGroupWiseForParentId(this.userGroupId, this.clientId,
                        this.ticketTypeId, value).subscribe((res4) => {
                            this.respObject = res4;
                            if (this.respObject.success) {
                                this.respObject.details.unshift(data);
                                this.allTicketTypes[index].options = this.respObject.details;
                               // this.categories = this.respObject.details;
                            } else {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            }
                        }, (err) => {
                            // this.isError = true;
                            // this.errorMessage = this.messageService.SERVER_ERROR;
                        });
                } else {
                    this._rest.getAttributesParentWiseWithPriority(this.clientId, value, this.priorityType, this.ticketTypeId).subscribe((res) => {
                        this.respObject = res;
                        // // console.log(JSON.stringify(this.respObject));

                        if (this.respObject.success) {
                            if (this.respObject.details.val) {
                                // data = this.allTicketTypes[index].options[0];
                                this.respObject.details.val.unshift(data);
                                this.allTicketTypes[index].options = this.respObject.details.val;
                            }
                            if (this.respObject.details.priority) {
                                this.priority = this.respObject.details.priority.name;
                                this.priorityId = this.respObject.details.priority.id;
                            }
                        } else {
                            if (index > -1) {
                                this.allTicketTypes[index].options = [data];
                            }
                            // this.notifier.notify('error', this.respObject.errorMessage);
                        }
                    }, (err) => {
                        this.notifier.notify('error', this.messageService.SERVER_ERROR);
                    });
                } 
            } else {
                this._rest.getAttributesParentWiseWithPriority(this.clientId, value, this.priorityType, this.ticketTypeId).subscribe((res) => {
                    this.respObject = res;
                    // // console.log(JSON.stringify(this.respObject));

                    if (this.respObject.success) {
                        if (this.respObject.details.val) {
                            // data = this.allTicketTypes[index].options[0];
                            this.respObject.details.val.unshift(data);
                            this.allTicketTypes[index].options = this.respObject.details.val;
                        }
                        if (this.respObject.details.priority) {
                            this.priority = this.respObject.details.priority.name;
                            this.priorityId = this.respObject.details.priority.id;
                        }
                    } else {
                        if (index > -1) {
                            this.allTicketTypes[index].options = [data];
                        }
                        // this.notifier.notify('error', this.respObject.errorMessage);
                    }
                }, (err) => {
                    this.notifier.notify('error', this.messageService.SERVER_ERROR);
                });
            } 
        }
    }

    ticketSearch() {
        this.advanceSearch({ 'offset': 0, 'paginationType': '' });
    }

    advanceSearch(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        console.log('offset====' + offset);
        if (offset === 0) {
            this.totalData = 0;
            this.totalPage = 0;
            this.page_no = 0;
        }
        // this.nextOffset = this.skip;
        console.log('nextOffset====' + this.nextOffset);
        // ==============================================================
        let ticketId;
        const tdate = this.messageService.ticketConverter(this.toDate, 1);
        if (tdate !== '') {
            this.toDate = tdate;
        } else {
            this.toDate = this.endDate;
        }
        const fdate = this.messageService.ticketConverter(this.fromDate, 1);
        if (fdate !== '') {
            this.fromDate = fdate;
        } else {
            this.fromDate = this.startDate;
        }
        let isError = false;
        // let cats;
        // console.log('this.cat.length====' + JSON.stringify(this.cat));
        if (this.cat.length > 0) {
            this.categoryFilter = '';
        }

        for (let i = 0; i < this.cat.length; i++) {
            if (this.cat[i].cid !== 0) {
                // console.log('this.cat===' + JSON.stringify(this.cat[i]));
                this.categoryFilter += this.cat[i].pid + '#' + this.cat[i].cid;
                if (i !== this.cat.length - 1) {
                    this.categoryFilter += ',';
                }
            } else {
                isError = true;
                break;
            }
        }
        const lastChar = this.categoryFilter.substr(-1);
        if (lastChar === ',') {
            this.categoryFilter = this.categoryFilter.substr(0, this.categoryFilter.length - 1);
        }


        if (this.categoryFilter === '') {
            this.categoryFilter = '0';
        }

        if (this.grpLevel > 1 || this.islead) {
            this.lead = 'Y';
        } else {
            this.lead = 'N';
        }

        if (this.ticket_id === '') {
            ticketId = 0;
        } else {
            ticketId = this.ticket_id;
        }

        if (this.raised !== '') {
            this.raisedTypeSelected = 1;
        } else {
            this.raisedTypeSelected = 0;
        }
        this.dataset = [];
        const data = {
            'ticketTypeId': this.ticketTypeId,
            'clientId': this.clientId,
            'supportgrp_id': this.userGroupSelected,
            'ticketStatusId': this.ticketStatusSelected,
            'ticket_id': ticketId,
            'busi_priority_id': this.prioritySelected,
            'created_frdate': this.fromDate,
            'created_todate': this.toDate,
            'catFilterLt': this.categoryFilter,
            'isTeamLead': this.lead,
            'raisedType': this.raisedTypeSelected,
            'raisedValue': this.raised,
            'assign_id': this.assigneeSelected,
            'grpLevel': this.grpLevel,
            'isDashboardSearch': 1,
            'ticketTypeSeqNo': this.seq,
            'page_size': this.pageSize,
            'nextOffset': offset,
            'paginationType': paginationType
        };
        if (ticketId.length < 6) {
            this.notifier.notify('error', 'Please enter last 6 digits of ticket id');
        } else if (this.raised !== '' && this.raisedTypeSelected === 0) {
            this.notifier.notify('error', 'Please select raised type');
        } else {
            this.ticketIdSearchLoaded = false;
            // console.log('this.grpLevel=' + this.grpLevel + ' ticketId.length=' + ticketId.length);
            if (this.grpLevel > 0 && (ticketId.length >= 6 || this.raised !== '')) {
                this._rest.searchTicketById(data).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.ticketIdSearchLoaded = true;
                        if (this.respObject.details.dataObj.length > 0) {
                            this.displayTicket(res, offset, paginationType);
                        } else {
                            this.notifier.notify('success', this.messageService.BLANK_RESULT);
                            this.dataset = [];
                        }
                    } else {
                        this.notifier.notify('error', this.respObject.errorMessage);
                    }
                });
            } else {
                this._rest.AdvancesearchTicket(data).subscribe((res) => {
                    this.respObject = res;
                    // console.log('loader=====', this.respObject.success);
                    if (this.respObject.success) {
                        this.ticketIdSearchLoaded = true;
                        if (this.respObject.details.dataObj.length > 0) {
                            this.displayTicket(res, offset, paginationType);
                        } else {
                            this.notifier.notify('success', this.messageService.BLANK_RESULT);
                            this.dataset = [];
                        }
                        // resolve(this.respObject);
                    } else {
                        this.notifier.notify('error', this.respObject.errorMessage);
                    }
                });
            }
        }
        // });
    }

    getNextData() {
        this.advanceSearch({ 'offset': this.nextOffset, 'paginationType': 'next' });
    }

    getPreviousData() {
        this.advanceSearch({ 'offset': this.previousOffset, 'paginationType': 'prev' });
    }

    onPageSizeChange(value
        :
        any
    ) {
        this.pageSize = this.pageSizeObj[value].value;
        this.advanceSearch({ 'offset': 0, 'paginationType': '' });
    }

    ngOnDestroy() {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }

        if (this.ticketTypeSubscription) {
            this.ticketTypeSubscription.unsubscribe();
        }

        // if (this.closeModalSubscribe) {
        //     this.closeModalSubscribe.unsubscribe();
        // }
        //
        // if (this.commentSubscribe) {
        //     this.commentSubscribe.unsubscribe();
        // }
    }

    onCellChanged(e, args) {
        // console.log(args.item);
    }

    handleSelectedRowsChanged(e, args) {
        if (Array.isArray(args.rows)) {
            this.selectedTitles = args.rows.map(idx => {
                const item = this.gridObj.getDataItem(idx);
                return item || '';
            });
            if (this.selectedTitles.length > 0) {
                this.show = true;
                this.selected = this.selectedTitles.length;
            } else {
                this.show = false;
            }
            // console.log(JSON.stringify(this.selectedTitles));
        }
    }

    onCellClicked(e, args) {
        const selectedRow = this.angularGrid.gridService.getColumnFromEventArguments(args);
        const data = selectedRow.dataContext;
        // console.log('data==========' + JSON.stringify(data));
        if (this.grpLevel > 0 && data.seq === this.AWAITING_USER_REPLY_SEQ) {
            this.isCreateTicket = true;
        } else {
            this.isCreateTicket = false;
        }
        this.messageService.setModalData(data);
    }

    nullCheck(value) {
        if (value === null || value === 'null') {
            return 'N/A';
        } else {
            return value;
        }
    }

    valueNullCheck(data) {
        const psObj = {};
        for (const k in data) {
            psObj[k] = this.nullCheck(data[k]);
        }
        // this.psInfo.push(psObj);
        return psObj;
    }

    changeRouting() {
        if (this.messageService.dashboardUrl !== undefined && this.messageService.dashboardUrl !== null) {
            this.messageService.changeRouting(this.messageService.dashboardUrl);
        }
    }

}

